import { formatEurAmount } from "../../../../formatEurAmount";
import type { FormatPricePropertyValue } from "./types";

export const formatPricePropertyValue: FormatPricePropertyValue = ({
  property,
  value,
  language,
  t,
}) => {
  switch (property) {
    case "amount": {
      return formatEurAmount({ amount: value, language });
    }
    case "hours": {
      return t("smartSurveyor.overview.price.hoursValue", {
        hours: new Intl.NumberFormat(language, {
          maximumFractionDigits: 2,
        }).format(value),
      });
    }
    case "hourlyRate": {
      return t("smartSurveyor.overview.price.ratePerHour", {
        rate: formatEurAmount({ amount: value, language }),
      });
    }
  }
};
